import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { FirestoreService } from "app/services/firestore.service";
import { TranslationService } from "app/services/translation.service";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-software",
  templateUrl: "./software.component.html",
  styleUrls: ["./software.component.scss"],
})
export class SoftwareComponent implements OnInit {
  public app_data;
  public current_lang;
  public i18n;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private translation_service: TranslationService,
    private firestore_service: FirestoreService
  ) {}

  ngOnInit(): void {
    //get dictionar<
    this.subscriptions.push(
      this.translation_service.current_dictionary_observable.subscribe(
        (dictionary) => {
          this.i18n = dictionary;
        }
      )
    );
    this.i18n = this.translation_service.getDictionary();

    // get language
    this.subscriptions.push(
      this.translation_service.current_lang_observable.subscribe((lang) => {
        this.current_lang = lang;
      })
    );
    this.current_lang = this.translation_service.getLanguage();

    // observe route changes
    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) this.fetchAppData();
      })
    );

    // get app_data
    this.fetchAppData();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  fetchAppData() {
    let id: string;
    console.log(this.router.url);
    switch (this.router.url) {
      case "/apps/draw-it":
        id = "uEjTFfSbANfOdCXFaC5B";
        break;
      case "/apps/dreaming-fox":
        id = "rWfepRFCTU5vdP5lT3n0";
        break;
      default:
        this.router.navigate([""]);
    }

    this.firestore_service.getAppData(id).subscribe((data) => {
      this.app_data = data;
    });
  }
}
